import Login from "pages/user/login/index.jsx";
import Index from "pages/index/index.jsx";
import Home from "pages/home/index.jsx";
import ErrorPage from "layouts/error.jsx";

const routes = [
    {
        path: '/',
        key:'',
        exact: true,
        component: Home,
        requiresAuth: false,
        backUrl: '/login',
        pathName:'首页',
        type:'home',    // type 'nav'菜单页
    },
    {
        path: '/login',
        key:'login',
        component: Login,
        pathName:'登录',
        type:'login'
    },
    {
        path: '/index',
        key:'index',
        component: Index,
        pathName:'首页',
        type:'index'
    },
    {
        path: '*',
        key:'404',
        component: ErrorPage,
        pathName:'404',
        type:'404'
    }
]


export default routes;